import React from 'react';
import { ComponentSkinProps } from '../../../../types/component-skin';
import '../FixedBgText.css';

/**
 * FixedBgText 컴포넌트의 기본 스킨
 * 배경 이미지 위에 텍스트 또는 HTML 콘텐츠를 표시
 */
interface BasicFixedBgTextSkinProps extends ComponentSkinProps {
  // 추가 props가 필요한 경우 여기에 정의
}

const BasicFixedBgTextSkin: React.FC<BasicFixedBgTextSkinProps> = (props) => {
  // props에서 data와 actions, utils 추출
  const {
    data: {
      id,
      isLoaded,
      hasError,
      componentRef,
      finalTitle,
      finalDescription,
      htmlContent,
      overlayStyle,
      contentStyle,
      textColor,
      htmlContentStyle,
      rootStyle,
      dataAttributes,
      debug,
      finalImageUrl,
      t
    },
    actions,
    utils,
    app,
    editor,
    mode
  } = props;

  return (
    <div 
      id={id}
      className="fixed-bg-text-component loaded"
      ref={componentRef}
      style={rootStyle as React.CSSProperties}
      {...dataAttributes}
    >
      <div className="overlay" style={overlayStyle}></div>
      <div className="content" style={contentStyle}>
        {htmlContent ? (
          <div className="html-content" style={htmlContentStyle} dangerouslySetInnerHTML={{ __html: htmlContent }} />
        ) : (
          <>
            <h2 className="title" style={{ color: textColor }}>
              {typeof finalTitle === 'string' ? t(finalTitle) : finalTitle}
            </h2>
            <p className="description" style={{ color: textColor }}>
              {typeof finalDescription === 'string' ? t(finalDescription) : finalDescription}
            </p>
          </>
        )}
      </div>
      
      {debug && (
        <div className="debug-info">
          <p>{t('Image URL')}: {finalImageUrl}</p>
          <p>{t('Is Loaded')}: {isLoaded ? t('Yes') : t('No')}</p>
          <p>{t('Has Error')}: {hasError ? t('Yes') : t('No')}</p>
          <p>{t('Window Width')}: {typeof window !== 'undefined' ? window.innerWidth : t('N/A')}</p>
        </div>
      )}
      
      {/* 에디터 모드에서 편집 힌트 표시 */}
      {mode === 'editor' && editor?.isSelected && (
        <div className="editor-hint" style={{
          position: 'absolute',
          top: '5px',
          right: '5px',
          background: 'rgba(0, 123, 255, 0.1)',
          color: '#007bff',
          padding: '2px 8px',
          borderRadius: '4px',
          fontSize: '12px',
          pointerEvents: 'none',
          zIndex: 10
        }}>
          {t('고정 배경 텍스트')}
        </div>
      )}
    </div>
  );
};

export default BasicFixedBgTextSkin;